import {Component, Input, Output, EventEmitter, OnChanges, SimpleChanges} from '@angular/core';

@Component({
    selector: 'app-camera-info-editor',
    templateUrl: './camera-info-editor.component.html',
    styleUrls: ['./camera-info-editor.component.scss']
})
export class CameraInfoEditorComponent implements OnChanges {
    @Input() disabled: boolean;
    @Input() type: string;
    @Input() description: string;
    @Input() posName: string;
    @Input() pitch: number;
    @Input() yaw: number;
    @Output() onEdit = new EventEmitter<{type: string, description: string, posName: string, pitch: number, yaw: number}>();

    constructor() {}

    update() {
        this.onEdit.emit({
            type: this.type,
            description: this.description,
            posName: this.posName,
            pitch: this.pitch,
            yaw: this.yaw,
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.type) {
            this.type = changes.type.currentValue;
        } else if (changes.description) {
            this.description = changes.description.currentValue;
        } else if (changes.posName) {
            this.posName = changes.posName.currentValue;
        } else if (changes.pitch) {
            this.pitch = changes.pitch.currentValue;
        } else if (changes.yaw) {
            this.yaw = changes.yaw.currentValue;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/camera-info-editor/camera-info-editor.component.ts